import React, { useState } from 'react';
import axios from 'axios';

// API URL - 从环境变量获取或使用默认值
const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5001/api';

function AdminTools() {
  const [isUploading, setIsUploading] = useState(false);
  const [isClearing, setIsClearing] = useState(false);
  const [message, setMessage] = useState('');
  
  // 从公共文件夹获取场景数据
  const fetchScenariosData = async () => {
    try {
      const response = await fetch('/combinedScenariosData.json');
      if (!response.ok) {
        throw new Error('Failed to fetch scenarios data');
      }
      return await response.json();
    } catch (error) {
      console.error('Error fetching scenarios data:', error);
      throw error;
    }
  };
  
  // 处理常规上传
  const handleUploadScenarios = async () => {
    setIsUploading(true);
    setMessage('');
    
    try {
      // 获取令牌
      const token = localStorage.getItem('token');
      if (!token) {
        throw new Error('认证令牌不存在');
      }
      
      // 获取场景数据
      const scenariosData = await fetchScenariosData();
      
      // 发送到API
      const response = await axios.post(
        `${API_URL}/admin/scenarios/upload`,
        { scenarios: scenariosData },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      
      // 检查响应
      if (!response.data.success) {
        throw new Error(response.data.message || 'Upload failed');
      }
      
      setMessage(`${response.data.count} scenarios uploaded successfully! Please refresh the page to see the results.`);
    } catch (error) {
      console.error('Error uploading scenarios:', error);
      setMessage(`Upload failed: ${error.message}`);
    } finally {
      setIsUploading(false);
    }
  };
  
  // 清除所有场景然后重新上传
  const handleResetAndUpload = async () => {
    setIsClearing(true);
    setMessage('');
    
    try {
      // 获取令牌
      const token = localStorage.getItem('token');
      if (!token) {
        throw new Error('认证令牌不存在');
      }
      
      // 获取场景数据
      const scenariosData = await fetchScenariosData();
      
      // 发送重置并上传请求
      const response = await axios.post(
        `${API_URL}/admin/scenarios/reset-and-upload`,
        { scenarios: scenariosData },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      
      // 检查响应
      if (!response.data.success) {
        throw new Error(response.data.message || 'Reset and upload failed');
      }
      
      setMessage(`All scenarios have been reset and ${response.data.count} new scenarios uploaded successfully! Please refresh the page.`);
    } catch (error) {
      console.error('Error resetting scenarios:', error);
      setMessage(`Reset and upload failed: ${error.message}`);
    } finally {
      setIsClearing(false);
    }
  };
  
  return (
    <div className="admin-tools">
      <h2>Admin Tools</h2>
      
      <div className="admin-buttons">
        <button 
          onClick={handleUploadScenarios} 
          disabled={isUploading || isClearing}
          className="admin-button"
        >
          {isUploading ? 'Uploading...' : 'Upload Test Scenarios'}
        </button>
        
        <button 
          onClick={handleResetAndUpload}
          disabled={isUploading || isClearing}
          className="admin-button reset-button"
        >
          {isClearing ? 'Resetting...' : 'Reset & Re-upload All Scenarios'}
        </button>
      </div>
      
      {message && (
        <p className={message.includes('successfully') ? 'success-message' : 'error-message'}>
          {message}
        </p>
      )}
    </div>
  );
}

export default AdminTools; 